<div class="about_us_wrap">
    <div class="our_mission_sections">
        <div class="our_mission_overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="mission_content">
                        <h1>我們的使命</h1>
                        <span>使英語寫作變得更加輕鬆</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="who_we_are_sections">
        <div class="container">
            <div class="row column_reverse">
                <div class="col-lg-8">
                    <div class="whot_we_are_content about_us_dots">
                        <h2>關於我們</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Trinka AI是專為學術和技術寫作而設計的下一代文法校正和語言增強寫作助手。開發團隊由渴望創造一個無障礙交流的未來的語言學家、工程師和資料科學家組成。我們的團隊構建了寫作助手來支持人們進行各種交流——從個人到學術再到日常對話。</p>
                        <p>Trinka AI 由英論閣提供技術支援。 英論閣是Crimson Interactive集團的一部分，該集團是一家擁有15年全球經驗的跨國公司。Crimson在125多個國家開展業務，擁有20萬多個客戶、600多名員工，並且雇用5000多名專家，並在北京、東京、首爾、新澤西、倫敦等地設有
                            10 個國際辦事處。</p>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="who_we_are_img">
                        <img src="../../../assets/images/whoWeAre_aboutus.png" alt="about us">
                    </div>
                </div>
            </div>

            <div class="row column_reverse prodcutName_sections">
                <div class="col-lg-4">
                    <div class="who_we_are_img">
                        <img src="../../../assets/images/TrinkaD'Cunha.jpg" alt="Trinka D'Cunha">
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="whot_we_are_content">
                        <h2>名字背後的故事</h2>
                        <div class="HeadingSubLine"></div>
                        <p>我們相信和尊重靈感、奉獻精神和遠見卓識，因此以首席語言學家Trinka D'Cunha的名字命名這個最新產品。她從第一天起就一直負責該計畫，直到它成為現實，以她名字命名這個工具是很有意義的。在Trinka的説明下，我們朝著消除語言障礙的使命邁出了一大步。</p>
                        <p>在設計這個先進的語言和文法修訂工具時，我們由目標一致的個人所組成的團隊至關重要。我們的創新產品證明了多年來的奉獻精神和創造性合作。如果不是每個成員的專業知識和決心，Trinka就不可能成為現實。</p>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div class="make_in_india_section">
        <div class="made_in_india_overlay"></div>
        <div class="container">
            <div class="row">
                <div class="col-md-8">
                    <div class="made_in_india_content">
                        <h2>印度製造</h2>
                        <div class="HeadingSubLine"></div>
                        <p>我們想讓印度具有更大的影響力！印度以其在資訊技術領域的快速增長而聞名，已成為全球頂級的IT中心之一。</p>
                        <p>儘管印度繼續快速增長，但很少有印度IT產品能夠在全球大眾市場上嶄露頭角——我們決心改變這一狀況。Trinka在印度構想和設計，我們相信它必將在人工智慧和自然語言處理的動態世界中留下持久的烙印。</p>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="made_in_india_img">
                        <img src="../../../assets/images/madeInIndia.png" alt="made in india">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="about_crimson_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="about_crimson_content">
                        <h2>關於Crimson</h2>
                        <div class="HeadingSubLine"></div>
                        <p>Crimson Interactive成立於2005年，是一家公認為研究和出版解決方案的全球領導者的跨國公司，也是研究人員、出版商、大學和企業信賴的合作夥伴，已協助來自125個國家超過兩百萬名科研作者。Crimson的客戶包括頂級大學，如麻省理工學院、普林斯頓大學、哥倫比亞大學和牛津大學等，以及豐田、威利、愛思唯爾、凱捷、松下、富士通、吉尼斯世界紀錄和日立等大型公司。</p>
                        <p>Crimson擁有眾多成功品牌，包括英論閣（Enago）、優譯堂（Ulatus）、Voxtab、Trinka.ai 和 Enago Life Sciences。Crimson的專業領域涵蓋科學出版解決方案、數位學習、本地化、醫療通信、人工智慧和媒體解決方案。它還是醫療保健和生物製藥公司的全球醫療通信合作夥伴。Crimson在全球10個主要國際地點設有辦事處，包括北京、東京、首爾、伊斯坦布爾、上海、倫敦、新澤西和紐約。</p>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="about_crimson_img">
                        <img src="../../../assets/images/aboutCrimson.jpg" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="crimson_brand_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="crimson_brand_content">
                        <h2>我們的品牌</h2>
                        <div class="HeadingSubLine"></div>
                        <ul>
                            <li>
                                <a href="https://www.enago.com/" class="enago_crimson" target="_blank">
                                    <div class="brand_overlay"></div>
                                    <img src="../../../assets/images/enago-crimson.png" alt="">
                                    <div class="text_overlay">
                                        <p>語言編輯服務</p>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.ulatus.com/" class="ulatus_crimson" target="_blank">
                                    <div class="brand_overlay"></div>
                                    <img src="../../../assets/images/ulatus-crimson.png" alt="">
                                    <div class="text_overlay">
                                        <p>翻譯服務</p>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.voxtab.com/" class="voxtab_crimson" target="_blank">
                                    <div class="brand_overlay"></div>
                                    <img src="../../../assets/images/voxtab-crimson.png" alt="">
                                    <div class="text_overlay">
                                        <p>轉錄服務</p>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="https://cloud.trinka.ai/signup?_rg=TW" class="trinka_crimson" target="_blank">
                                    <div class="brand_overlay"></div>
                                    <img src="../../../assets/images/trinka-crimson.png" alt="">
                                    <div class="text_overlay">
                                        <p>語法糾正和寫作助理 </p>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a href="https://lifesciences.enago.com/" class="lifes_crimson" target="_blank">
                                    <div class="brand_overlay"></div>
                                    <img src="../../../assets/images/lifes-crimson.png" alt="">
                                    <div class="text_overlay">
                                        <p>醫學出版物</p>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="global_offices">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>我們的全球網點</h2>
                    <div class="HeadingSubLine"></div>
                    <p>我們在世界各地都設有分支機搆，以更好地為學術界提供服務。</p>
                    <div class="global-presence-wrap mart-20">
                        <div class="global-maps" style="position: relative;">
                            <div class="row">
                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap usa marr-10" id="usa" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">New Jersey,<br/> USA</div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap usa padb-20" id="usaview">
                                    <div class="row">
                                        <div class="col-md-12 col-xs-12 global-location">
                                            <div class="location-wrap" style="margin-left: 50px;">
                                                <h3>New Jersey, USA</h3>
                                                <p class="marb-10">
                                                    <br>&nbsp;
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap korea marr-20" id="korea" onclick="viewlocation(id)">

                                    <div class="map-box"></div>
                                    <div class="location-name">Seoul, Korea </div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap korea padb-20" id="koreaview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>Seoul, Korea</h3>
                                            <p>Crimson Interactive Korea Co., Ltd.
                                                <br> #803-74, 1-Dong, 775, Gyeongin-ro, Yeongdeungpo-gu, Seoul, Republic of Korea
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap china marr-20" id="china" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">Beijing / Shanghai, China</div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap china padb-20" id="chinaview">
                                    <div class="row">
                                        <div class="col-md-6  col-sm-6  col-xs-12 global-location">
                                            <div class="location-wrap" style="margin-left: 50px;">
                                                <h3>Beijing, China</h3>
                                                <p class="marb-10">Room 607, Attempt Center, No. A6 Zhongguancun South Street, Haidian District,
                                                    Beijing, China - 100086
                                                    <br>
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-md-6  col-sm-6 col-xs-12  global-location">
                                            <div class="location-wrap" style="margin-left: 50px;">
                                                <h3>Shangai, China</h3>
                                                <p class="marb-10">Room 101, No. 110, Tianlinshiyicun, Xuhui District, Shanghai 200233
                                                    <br>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap japan marr-20" id="japan" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">Tokyo, Japan</div>
                                </div>
                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap japan padb-20" id="japanview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>Tokyo, Japan</h3>
                                            <p class="marb-10">Crimson Interactive K.K.
                                                <br> 4th Daini-Denpa Building, 2-14-10 Soto-Kanda, Chiyoda-ku, Tokyo, 101-0021,
                                                Japan
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap india" id="india" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">Mumbai, India</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap india padb-20" id="indiaview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>Mumbai, India</h3>
                                            <p class="marb-10">Crimson Interactive
                                                <br> 1001, 10th Floor, Techniplex - II, Veer Savarkar Flyover, S. V. Road, Goregaon
                                                (W), Mumbai 400062, India
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap uk" id="uk" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">London, United Kingdom</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap uk padb-20" id="ukview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>London, United Kingdom</h3>
                                            <p class="marb-10">Woodberry House, 2 Woodberry Grove, Finchley, London, N12 0DR, United Kingdom
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap turkey" id="turkey" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">Istanbul,
                                        <br />Turkey</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap turkey padb-20" id="turkeyview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>Istanbul, Turkey</h3>
                                            <p class="marb-10">Levent Mah. Ulgen Sok. No:52 Besiktas Istanbul, TURKEY
                                                <br>
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-3 col-xs-12 col-sm-4 map-wrap taiwan active" id="taiwan" onclick="viewlocation(id)">
                                    <div class="map-box"></div>
                                    <div class="location-name">Taipei,
                                        <br> Taiwan</div>
                                </div>

                                <div class="col-md-12 col-sm-12 col-xs-12 global-location-wrap taiwan padb-20 show" id="taiwanview">
                                    <div class="col-md-12  col-sm-12 col-xs-12 global-location">
                                        <div class="location-wrap">
                                            <h3>Taipei, Taiwan</h3>
                                            <p class="marb-10">
                                                2F, No. 40, Ln 91, Sec.1,
                                                <br> Neihu Road, Neihu Dist., Taipei City 11441, Taiwan.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="no_of_glance_section">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="glance_heading">
                        <div class="howItWorkHeading lineWhiteColor">
                            <h2>數據一覽</h2>
                            <div class="HeadingSubLine"></div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="glance_contents">
                        <div class="row">
                            <div class="col-md-6 col-sm-6">
                                <div class="glance_container">
                                    <div class="glance_icons">
                                        <img src="../../../assets/images/Aboutus-author.png" alt="">
                                    </div>
                                    <p>兩百萬+作者</p>
                                </div>
                            </div>

                            <div class="col-md-6 col-sm-6">
                                <div class="glance_container">
                                    <div class="glance_icons">
                                        <img src="../../../assets/images/aboutus_satisfy.png" alt="">
                                    </div>
                                    <p>顧客滿意度</p>
                                </div>
                            </div>

                            <div class="col-md-6 col-sm-6">
                                <div class="glance_container">
                                    <div class="glance_icons">
                                        <img src="../../../assets/images/aboutus_degree_cap.png" alt="">
                                    </div>
                                    <p>2000多名博士/碩士專家</p>
                                </div>
                            </div>

                            <div class="col-md-6 col-sm-6">
                                <div class="glance_container">
                                    <div class="glance_icons">
                                        <img src="../../../assets/images/globe.svg" alt="" style="width: 40px;">
                                    </div>
                                    <p>125多個國家/地區</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="about_us_our_client">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>我們的客戶</h2>
                    <div class="HeadingSubLine"></div>
                    <ul class="nav nav-tabs" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" data-toggle="tab" href="#UniversityPartners" role="tab">大學合作夥伴</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" data-toggle="tab" href="#Corporates_sections" role="tab">公司</a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div class="tab-pane active" id="UniversityPartners" role="tabpanel">
                            <ul>
                                <li>
                                    <img src="../../../assets/images/client_logos/Columbia_Univ_207.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Duke_Univ.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Priceton_Univ.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Purdue_Univ.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/MIT.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Technical-University-of-Denmark.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Univ_of_Birmingham.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Yonsei_University.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/University_of_Gassgow.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Washinton_State_Univ.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Korea_University.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/KyotoUniversityLogo.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Peking-University.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/Tsinghua_University79.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/client_logos/University_of_Tokyo.png" alt="">
                                </li>
                            </ul>
                        </div>
                        <div class="tab-pane" id="Corporates_sections" role="tabpanel">
                            <ul>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/wiley-logo.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/IBMWatson-logo.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/bombay-stock.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/Netflix-logo.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/toyota_log.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/guiness_world_Recodos.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/oup.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/Johnson-logo.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/sony_logo.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/bankofjapan.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/abbott.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/FujiTsu_logo.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/DowJones-logo.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/canon_logo.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/pfizer-logo.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/sanofi_logo.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/RBS_logo.png" alt="">
                                </li>
                                <li>
                                    <img src="../../../assets/images/Corporates_logos/iifl-logo.png" alt="">
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="awards_certifications">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>獲獎及認證</h2>
                    <div class="HeadingSubLine"></div>
                    <div class="cover_wrapper">
                        <div id="client-logos" class="owl-carousel">
                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="../../../assets/images/golden-bridge-medal.png" alt="">
                                    </div>
                                    <p>The Golden Bridge Awards For Best Entrepreneur (Women)</p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="../../../assets/images/pharma-award.png" alt="">
                                    </div>
                                    <p>APAC CIO Outlook Top 10 Pharma & Life Science Tech Solution Providers</p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="../../../assets/images/ksci.png" alt="">
                                    </div>
                                    <p>Korea
                                        <br /> Satisfaction Consumer
                                        <br /> Index
                                    </p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="../../../assets/images/bizz-award.png" alt="">
                                    </div>
                                    <p>Bizz Award For Business Excellence</p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="../../../assets/images/qms-award.png" alt="">
                                    </div>
                                    <p>The World Quality
                                        <br /> Commitment Award</p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="../../../assets/images/red-awards.png" alt="">
                                    </div>
                                    <p>Red Herring Top 100 Asia
                                        <br /> and Global Awards!</p>
                                </div>
                            </div>

                            <div class="item">
                                <div class="client_inners">
                                    <div class="award_img">
                                        <img src="../../../assets/images/sme-award.png" alt="">
                                    </div>
                                    <p>Google SME Award</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="our_values_slider">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h2>我們的價值</h2>
                    <div class="HeadingSubLine"></div>
                    <div id="customers-testimonials" class="owl-carousel">
                        <div class="item">
                            <div class="shadow-effect">
                                <h4>社會責任</h4>
                                <p>我們相信，經由道德和透明的行為，我們能夠對社會和環境產生積極影響，推動社會的可持續發展。</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="shadow-effect">
                                <h4>尊重</h4>
                                <p>在與文化、人和環境打交道時，我們踐行尊重的價值觀。對學習者和老師的尊重體現在我們堅定不移地努力實現他們的期望，我們也堅持在不同的文化背景下踐行禮貌、耐心和敏感的美德。</p>
                            </div>
                        </div>

                        <div class="item">
                            <div class="shadow-effect">
                                <h4>Wow</h4>
                                <p>“Wow”是我們價值體系的核心，這意味著要以超出所有期望的方式交付我們的工作。我們堅持不懈地努力通過改善溝通和提供創新的學習體驗來實現“Wow”。
                                </p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="shadow-effect">
                                <h4>精益求精</h4>
                                <p>精益求精的價值觀意味著我們堅持持續改進，它構成了我們所有教學的核心。改善的本質是創新，我們將技術和人力作為創新的關鍵驅動力實現持續的改善。</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="shadow-effect">
                                <h4>創新</h4>
                                <p>我們相信，在提高學習者學習能力的同時，我們可以實現對既有實踐的創新體驗，增進我們的任務目標。</p>
                            </div>
                        </div>
                        <div class="item">
                            <div class="shadow-effect">
                                <h4>簡單</h4>
                                <p>簡單意味著我們專注於透過尖端技術支援的簡單流程，以最有效的方式提供卓越的服務品質。這體現在我們易於使用的使用者介面、易於瀏覽的網站、明確的服務條款和條件，以及個人化的服務。</p>
                            </div>
                        </div>

                    </div>
                    <div class="slider_background_shadow"></div>

                </div>
            </div>
        </div>
    </div>

    <div class="about_us_footer_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="footer_sections_abouts">
                        <p>您是否想投入自己的原創思維和專業知識，加入快速發展的自然語言處理世界？如果您的回答是“是”，那讓我們攜手並進，一起攀登新的高度！</p>
                        <a href="https://www.trinka.ai/tw/workwithus" target="_blank">加入我們</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>